var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-page-header",
        {
          staticClass: "page-header",
          on: {
            back: function ($event) {
              return _vm.$emit("back")
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { slot: "title" },
              on: {
                click: function ($event) {
                  return _vm.$emit("back")
                },
              },
              slot: "title",
            },
            [
              _vm._v("\n      返回 班级管理/\n      "),
              _c("span", { staticStyle: { color: "#297ede" } }, [
                _vm._v(_vm._s(_vm.cardObj.title)),
              ]),
            ]
          ),
        ]
      ),
      _c("div", { staticStyle: { padding: "0 20px" } }, [
        _c(
          "div",
          { staticStyle: { margin: "15px 0" } },
          [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "10px", "font-size": "17px" } },
              [_vm._v(_vm._s(_vm.cardObj.title))]
            ),
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.downloadWord } },
              [_vm._v("下载主题word文档")]
            ),
          ],
          1
        ),
        _c(
          "div",
          [_c("WordParser", { attrs: { fileUrl: _vm.cardObj.fileUrl } })],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }